module.exports = __webpack_public_path__ + "img/tomas-niborski.e57f4c4c.jpg";